import { useCallback } from 'react';
import { buildService } from '../service';
import serviceMethods from '../service_methods';
const api = buildService('/superset', {
  only: ['get']
});
const supersetService = {
  useFetchAdminDashboardGuestToken(setLoading, initialQueryParams) {
    const [guestToken, setGuestToken, fetchGuestToken] = serviceMethods.useFetch({
      callback: useCallback(async queryParams => {
        const response = await api.get();
        return response;
      }, []),
      setLoading,
      initialQueryParams: initialQueryParams || '',
      initialStateValue: null
    });
    return [guestToken, setGuestToken, fetchGuestToken];
  }
};
export default supersetService;